import { render, staticRenderFns } from "./screen4.vue?vue&type=template&id=ecd3202c&scoped=true&"
import script from "./screen4.vue?vue&type=script&lang=js&"
export * from "./screen4.vue?vue&type=script&lang=js&"
import style0 from "./screen4.vue?vue&type=style&index=0&id=ecd3202c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd3202c",
  null
  
)

export default component.exports